import {Component, createRef} from 'react';
import Draggable from 'react-draggable';


class AlertTextPopup extends Component {
            constructor(props) {
              super(props);
              this.state={
              }
              this.hintTable = [];
              this.nodeRef = createRef(); 
    }

    buildHintTable(){
        this.hintTable = [];
        for (let i=0; i<this.props.hintNbr; i++){
            this.hintTable.push(this.props.alertText[i]);
        }
    }
        
    render() {
        this.buildHintTable();
        this.alertText = this.hintTable.map((hint,key) => <li key={key}>{hint}</li>);

    return ( 
          <div className="modal-overlay">
        <Draggable handle=".modal-header" nodeRef={this.nodeRef}>
          <div className="custom-modal" ref={this.nodeRef}>
            <div className="modal-header modal-header-green alert">
              <span>
                {this.props.title}
                <button className="modal-close-btn" onClick={this.props.closeAlert}
                  onTouchEnd={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.closeAlert()
                            }} >
                  Close
                </button>
              </span>
            </div>
            <div className="modal-body">
              <div className="alert">{this.alertText}</div>
              <div className="text-center font-weight-bold">
                You can drag this box out of the way in order to read the underlying text.
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    );
  
    }
}

export default AlertTextPopup;